import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const ADD_QUOTE = "createMantra";
const REMOVE_QUOTE = "deleteMantra";
const GET_QUOTE = "getAllMantra";
const EDIT_QUOTE = "updateMantra";

export default {
  AddQuote(payload) {
    return Repository.post(transformRoute(ADD_QUOTE), payload);
  },
  removeQuote(payload) {
    return Repository.post(transformRoute(REMOVE_QUOTE), payload);
  },
  getQuoteData(payload) {
    return Repository.post(transformRoute(GET_QUOTE), payload);
  },
  editQuote(payload) {
    return Repository.post(transformRoute(EDIT_QUOTE), payload);
  },
};

const transformRoute = (route) => {
  return `appservices/mantra/${route}`;
};
